import HeroBackdrop from "@/components/home/hero/HeroBackdrop";
import HeroHeadline from "@/components/home/hero/HeroHeadline";
import HeroCallouts from "@/components/home/hero/HeroCallouts";
import HeroAside from "@/components/home/hero/HeroAside";

export default function HeroSection() {
  return (
    <section className="relative h-[100vh] min-h-[680px] w-full overflow-hidden">
      <HeroBackdrop />
      <div className="relative z-10 h-full max-w-[1480px] mx-auto px-6 md:px-12 flex flex-col justify-end pb-24 md:pb-32">
        <div className="max-w-4xl">
          <HeroHeadline />
          <HeroCallouts />
        </div>
      </div>
      <HeroAside />
    </section>
  );
}
